import React, { useContext } from 'react';
import styled from 'styled-components';
import WordArt from 'react-wordart';
import Context from '../Context';
import { width100, displayFlex } from '../constants';
import RaisedButton from './Buttons/RaisedButton';

const Header = styled.div`
  ${displayFlex}
  ${width100}
  margin-top: 2rem;
  margin-bottom: 1.75rem;
`;

const navigationButton = {
  height: 'fit-content',
  fontSize: 'inherit',
  textAlign: 'center',
  padding: '0.25rem',
  // marginLeft: '1.5rem',
  width: 'auto',
  marginLeft: '-4rem',
  marginTop: '5.5rem',
};

export default function HeaderComponent() {
  const { setSingleChannel, singleChannel, isLoaded } = useContext(Context);

  const buttonName = singleChannel ? 'HOME' : 'THE MIXES';
  return (
    <Header>
      <WordArt text="Video-Net" theme="superhero" fontSize={80} />
      {isLoaded && (
        <RaisedButton
          background="blue"
          hover="red"
          color="yellow"
          onClick={() => setSingleChannel(!singleChannel)}
          style={navigationButton}
        >
          {buttonName}
        </RaisedButton>
      )}
    </Header>
  );
}
